export class GlasContainerReturnChannelForm {
  constructor() {
    this.returnChannelFormElement = document.querySelector(".contact-form-glas-container-return-channel");
    this.currentContainerText = this.returnChannelFormElement?.querySelector(".glas-container-form-text-current-container");
    this.currentContainerFields = this.returnChannelFormElement?.querySelectorAll(".current-container-field");
    this.isNewLocationField = this.returnChannelFormElement?.querySelector('input[id*="isNewLocation"]');
    this.locationIcon = this.returnChannelFormElement?.querySelector(".marker");
    this.locationText = this.returnChannelFormElement?.querySelector(".glas-container-form-location-text");
    this.locationNotFoundMessage = this.returnChannelFormElement?.querySelector(".glas-container-form-location-not-found");
    this.locationField = this.returnChannelFormElement?.querySelector('input[id*="location"]');
    this.latitudeField = this.returnChannelFormElement?.querySelector('input[id*="latitude"]');
    this.longitudeField = this.returnChannelFormElement?.querySelector('input[id*="longitude"]');
    this.defineFormFields();
    this.locationIcon?.addEventListener("click", () => this.getUserPosition());
    this.isNewLocationField?.addEventListener("change", () => this.newLocationFieldHandler());
    this.locationField?.addEventListener("change", () => this.locationFieldHandler());
  }
  defineFormFields() {
    this.formFields = {
      containerUid: this.returnChannelFormElement?.querySelector('input[id*="containerUid"]'),
      containerDisposalCompany: this.returnChannelFormElement?.querySelector('input[id*="containerDisposalCompany"]'),
      containerDistrict: this.returnChannelFormElement?.querySelector('input[id*="containerDistrict"]'),
      containerStreet: this.returnChannelFormElement?.querySelector('input[id*="containerStreet"]'),
      containerZip: this.returnChannelFormElement?.querySelector('input[id*="containerZip"]'),
      containerCity: this.returnChannelFormElement?.querySelector('input[id*="containerCity"]'),
      containerSupplementLocationInfo: this.returnChannelFormElement?.querySelector('input[id*="containerSupplementLocationInfo"]'),
      containerPrivate: this.returnChannelFormElement?.querySelector('input[id*="containerPrivate"]'),
      containerLongitude: this.returnChannelFormElement?.querySelector('input[id*="containerLongitude"]'),
      containerLatitude: this.returnChannelFormElement?.querySelector('input[id*="containerLatitude"]')
    };
  }
  setFormFieldValues() {
    this.formFields.containerUid.value = this.glasContainerLocation.uid.toString();
    this.formFields.containerDisposalCompany.value = this.glasContainerLocation.disposalCompany;
    this.formFields.containerDistrict.value = this.glasContainerLocation.district;
    this.formFields.containerStreet.value = this.glasContainerLocation.street;
    if (this.formFields.containerStreet.value) {
      this.formFields.containerStreet.type = "text";
    }
    this.formFields.containerZip.value = this.glasContainerLocation.zip.toString();
    if (this.formFields.containerZip.value) {
      this.formFields.containerZip.type = "text";
    }
    this.formFields.containerCity.value = this.glasContainerLocation.city;
    if (this.formFields.containerCity.value) {
      this.formFields.containerCity.type = "text";
    }
    this.formFields.containerSupplementLocationInfo.value = this.glasContainerLocation.supplementLocationInfo;
    if (this.formFields.containerSupplementLocationInfo.value) {
      this.formFields.containerSupplementLocationInfo.type = "text";
    }
    this.formFields.containerPrivate.value = this.glasContainerLocation.private.toString();
    this.formFields.containerLongitude.value = this.glasContainerLocation.longitude.toString();
    this.formFields.containerLatitude.value = this.glasContainerLocation.latitude.toString();
    if (this.currentContainerText.classList.contains("hidden")) {
      this.currentContainerText.classList.remove("hidden");
    }
  }
  getUserPosition() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        if (position) {
          this.userPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.fillReturnChannelFormWithUserLocation();
          this.showLocationText();
          const longitude = this.locationText.querySelector(".lng");
          const latitude = this.locationText.querySelector(".lat");
          longitude.innerText = this.userPosition.lng.toString();
          latitude.innerText = this.userPosition.lat.toString();
        }
      }, (error) => {
        this.showErrorMessage();
        console.log(error);
      });
    } else {
      this.showErrorMessage();
    }
  }
  showLocationText() {
    this.locationNotFoundMessage.classList.add("hidden");
    this.locationText.classList.remove("hidden");
  }
  showErrorMessage() {
    this.locationNotFoundMessage.classList.remove("hidden");
    this.locationText.classList.add("hidden");
  }
  locationFieldHandler() {
    this.locationNotFoundMessage.classList.add("hidden");
    this.locationText.classList.add("hidden");
    this.latitudeField.value = "";
    this.longitudeField.value = "";
  }
  newLocationFieldHandler() {
    if (this.isNewLocationField.value === "1") {
      this.clearCurrentContainerFields();
    } else {
      this.setFormFieldValues();
    }
  }
  showForm() {
    this.returnChannelFormElement.classList.remove("hidden");
    this.returnChannelFormElement.classList.add("padding-top--m", "padding-bottom--m");
  }
  fillReturnChannelFormWithCurrentContainer(glasContainerLocation) {
    this.glasContainerLocation = glasContainerLocation;
    this.showForm();
    this.clearCurrentContainerFields();
    this.setFormFieldValues();
    this.isNewLocationField.value = "0";
    this.scrollToFormWithHeaderOffset();
  }
  fillReturnChannelFormForNewLocation(glasContainerLocation) {
    this.glasContainerLocation = glasContainerLocation;
    this.showForm();
    this.clearCurrentContainerFields();
    this.isNewLocationField.value = "1";
    this.scrollToFormWithHeaderOffset();
  }
  fillReturnChannelFormWithUserLocation() {
    this.latitudeField.value = this.userPosition.lat.toString();
    this.longitudeField.value = this.userPosition.lng.toString();
    this.locationField.value = this.returnChannelFormElement.dataset.location;
  }
  clearCurrentContainerFields() {
    if (!this.currentContainerText.classList.contains("hidden")) {
      this.currentContainerText.classList.add("hidden");
    }
    this.currentContainerFields.forEach((input) => {
      if (input.type === "text") {
        input.type = "hidden";
      }
      input.value = "";
    });
  }
  scrollToFormWithHeaderOffset() {
    const stickyHeaderHeight = document.querySelector(".header--sticky")?.clientHeight || 0;
    const formPosition = this.returnChannelFormElement.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({top: formPosition - stickyHeaderHeight, behavior: "smooth"});
  }
}
